import { getColor, getSize, getWeight } from "views/resources/theme";
import styled from "styled-components";

export const TopView = styled.div`
	display: flex;
	justify-content: space-evenly;
	position: relative;
	align-items: center;
	border-bottom: 2px dashed ${getColor("secondaryDark")};
	height: 80px;

	.officeName {
		color: ${getColor("fg")};
		font-weight: ${getWeight("semibold")};
		max-width: 50%;
		margin: 0;
		display: inline-block;
		/* padding: 10px ${getSize("m")}; */
		/* font-size: ${getSize("m")}; */
		/* text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
		max-height: 3.6em;
		line-height: 1.8em; */
	}

	&::before,
	&::after {
		display: block;
		position: absolute;
		margin: 0;
		padding: 0;
		bottom: -17px;
		background-color: white;
		content: "";
		width: 30px;
		height: 30px;
		border-radius: 50%;
		z-index: 100;
	}
	&::before {
		left: -21px;
	}
	&::after {
		right: -21px;
	}
`;

export const BotView = styled.div`
	display: flex;
	position: relative;
	justify-content: space-around;
	margin: ${getSize("s")} ${getSize("s")} 0 ${getSize("s")};
	height: 80px;

	/* margin-bottom: 21px; */
	padding-top: 15px;
	&::before,
	&::after {
		display: block;
		position: absolute;
		margin: 0;
		padding: 0;
		top: -23px;
		background-color: white;
		content: "";
		width: 30px;
		height: 30px;
		border-radius: 50%;
		box-shadow: inset 0px 0px 4px gray;
	}
	&::after {
		left: -23px;
	}
	&::before {
		right: -23px;
	}
`;

export const DateView = styled.div`
	display: flex;
	justify-content: space-around;
	align-items: center;
	align-content: center;
	padding-bottom: 12px;
	height: 40px;
	border-top: 1px solid #eeeeee;
	h4.title {
		display: inline-block;
		font-size: ${getSize("sm")};
		font-size: 12px;
		font-weight: 500;
		margin: 0;
		display: block;
		color: #4a4a4a;
	}
	h4.body,
	h5.body {
		display: inline-block;
		color: ${getColor("primary")};
		margin: 0;
	}
`;

export const Wrapper = styled.div`
	background-color: ${getColor("bg")};
	border-radius: ${getSize("s")};
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
	height: 200px;
	position: relative;
	min-width: 315px;
	width: ${({ notification, inTicketScreen }) =>
		notification ? "100%" : inTicketScreen ? "70%" : "315px"};
	border-radius: 10px;
	padding: 0;
	margin-bottom: 24px;

	.info {
		text-align: center;

		span {
			font-size: ${getSize("sm")};
			font-size: 12px;
			font-weight: 500;
			margin: 0;
			display: block;
			color: #4a4a4a;
		}

		h4 {
			color: ${getColor("primary_light")};
			color: #145ab4;
			margin: 0;
			padding: 0;
			font-size: 14px;
			font-weight: bold;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		&.right {
			max-width: 50%;
		}

		&.left h4 {
			font-family: Roboto;
			font-size: 28px;
			font-weight: 900;
		}
	}
`;
